const SCROLL_ANIMATION_TRIGGER_CLASSNAME = 'scroll-trigger';
const SCROLL_ANIMATION_OFFSCREEN_CLASSNAME = 'scroll-trigger--offscreen';
const SCROLL_ZOOM_IN_TRIGGER_CLASSNAME = 'animate--zoom-in';
const SCROLL_ANIMATION_CANCEL_CLASSNAME = 'scroll-trigger--cancel';

// Scroll in animation logic
function onIntersection(elements, observer) {
  elements.forEach((element, index) => {
    if (element.isIntersecting) {
      const elementTarget = element.target;
      if (elementTarget.classList.contains(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME)) {
        elementTarget.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
        if (elementTarget.hasAttribute('data-cascade'))
          elementTarget.setAttribute('style', `--animation-order: ${index};`);
      }
      observer.unobserve(elementTarget);
    } else {
      element.target.classList.add(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
      element.target.classList.remove(SCROLL_ANIMATION_CANCEL_CLASSNAME);
    }
  });
}

function initializeScrollAnimationTrigger(rootEl = document, isDesignModeEvent = false) {
  const animationTriggerElements = Array.from(rootEl.getElementsByClassName(SCROLL_ANIMATION_TRIGGER_CLASSNAME));
  if (animationTriggerElements.length === 0) return;

  if (isDesignModeEvent) {
    animationTriggerElements.forEach((element) => {
      element.classList.add('scroll-trigger--design-mode');
    });
    return;
  }

  const observer = new IntersectionObserver(onIntersection, {
    rootMargin: '0px 0px -50px 0px',
  });
  animationTriggerElements.forEach((element) => observer.observe(element));
}

// Zoom in animation logic
function initializeScrollZoomAnimationTrigger() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const animationTriggerElements = Array.from(document.getElementsByClassName(SCROLL_ZOOM_IN_TRIGGER_CLASSNAME));

  if (animationTriggerElements.length === 0) return;

  const scaleAmount = 0.2 / 100;

  animationTriggerElements.forEach((element) => {
    let elementIsVisible = false;
    const observer = new IntersectionObserver((elements) => {
      elements.forEach((entry) => {
        elementIsVisible = entry.isIntersecting;
      });
    });
    observer.observe(element);

    element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));

    window.addEventListener(
      'scroll',
      throttle(() => {
        if (!elementIsVisible) return;

        element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));
      }),
      { passive: true }
    );
  });
}

function percentageSeen(element) {
  const viewportHeight = window.innerHeight;
  const scrollY = window.scrollY;
  const elementPositionY = element.getBoundingClientRect().top + scrollY;
  const elementHeight = element.offsetHeight;

  if (elementPositionY > scrollY + viewportHeight) {
    // If we haven't reached the image yet
    return 0;
  } else if (elementPositionY + elementHeight < scrollY) {
    // If we've completely scrolled past the image
    return 100;
  }

  // When the image is in the viewport
  const distance = scrollY + viewportHeight - elementPositionY;
  let percentage = distance / ((viewportHeight + elementHeight) / 100);
  return Math.round(percentage);
}

window.addEventListener('DOMContentLoaded', () => {
  initializeScrollAnimationTrigger();
  initializeScrollZoomAnimationTrigger();
});

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => initializeScrollAnimationTrigger(event.target, true));
  document.addEventListener('shopify:section:reorder', () => initializeScrollAnimationTrigger(document, true));
}

function getVisibleBottleImage(cardElement) {
  const desktopBottle = cardElement.querySelector('.kf-wine-card__bottle--desktop .kf-wine-card__img');
  const mobileBottle = cardElement.querySelector('.kf-wine-card__bottle--mobile .kf-wine-card__img');

  if (desktopBottle && desktopBottle.offsetParent !== null) return desktopBottle;
  if (mobileBottle) return mobileBottle;
  return desktopBottle || null;
}

function animateBottleToCart(cardElement) {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const sourceImage = getVisibleBottleImage(cardElement);
  const cartTarget = document.querySelector('#cart-icon-bubble') || document.querySelector('.header__icon--cart');
  if (!sourceImage || !cartTarget) return;

  const sourceRect = sourceImage.getBoundingClientRect();
  const targetRect = cartTarget.getBoundingClientRect();
  const clone = sourceImage.cloneNode(true);

  clone.style.position = 'fixed';
  clone.style.left = `${sourceRect.left}px`;
  clone.style.top = `${sourceRect.top}px`;
  clone.style.width = `${sourceRect.width}px`;
  clone.style.height = `${sourceRect.height}px`;
  clone.style.objectFit = 'contain';
  clone.style.pointerEvents = 'none';
  clone.style.zIndex = '9999';
  clone.style.willChange = 'transform, opacity';
  clone.style.filter = 'drop-shadow(4px 8px 12px rgba(0,0,0,0.2))';

  document.body.appendChild(clone);

  const translateX = targetRect.left + targetRect.width / 2 - (sourceRect.left + sourceRect.width / 2);
  const translateY = targetRect.top + targetRect.height / 2 - (sourceRect.top + sourceRect.height / 2);

  const animation = clone.animate(
    [
      { transform: 'translate(0, 0) scale(1)', opacity: 1 },
      { transform: `translate(${translateX * 0.65}px, ${translateY * 0.6}px) scale(0.65)`, opacity: 0.92, offset: 0.65 },
      { transform: `translate(${translateX}px, ${translateY}px) scale(0.22)`, opacity: 0.1 },
    ],
    {
      duration: 700,
      easing: 'cubic-bezier(0.2, 0.8, 0.2, 1)',
      fill: 'forwards',
    }
  );

  animation.onfinish = () => {
    clone.remove();
    cartTarget.classList.remove('kf-cart-bubble-bump');
    void cartTarget.offsetWidth;
    cartTarget.classList.add('kf-cart-bubble-bump');
  };
}

function updateCartBubbleCount(itemCount) {
  const cartIconBubble = document.querySelector('#cart-icon-bubble');
  if (!cartIconBubble) return;

  let countBubble = cartIconBubble.querySelector('.cart-count-bubble');
  if (!countBubble && itemCount > 0) {
    countBubble = document.createElement('div');
    countBubble.className = 'cart-count-bubble';
    cartIconBubble.appendChild(countBubble);
  }
  if (!countBubble) return;

  if (itemCount <= 0) {
    countBubble.remove();
    return;
  }

  if (!countBubble.querySelector('span[aria-hidden="true"]')) {
    const visibleCount = document.createElement('span');
    visibleCount.setAttribute('aria-hidden', 'true');
    countBubble.appendChild(visibleCount);
  }

  if (!countBubble.querySelector('.visually-hidden')) {
    const srOnly = document.createElement('span');
    srOnly.className = 'visually-hidden';
    countBubble.appendChild(srOnly);
  }

  const countElements = countBubble.querySelectorAll('span[aria-hidden="true"]');
  countElements.forEach((el) => {
    el.textContent = itemCount;
  });

  const srOnly = countBubble.querySelector('.visually-hidden');
  if (srOnly) {
    srOnly.textContent = `${itemCount} items`;
  }

  countBubble.classList.remove('hidden');
}

let kfToastTimer;
let kfCachedCartData = null;

if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
  subscribe(PUB_SUB_EVENTS.cartUpdate, (eventData) => {
    if (eventData?.source === 'kf-card-product') return;

    if (eventData?.cartData) {
      kfCachedCartData = eventData.cartData;
      updateAllAddToCartStockState(eventData.cartData);
      return;
    }

    kfCachedCartData = null;
    refreshAllAddToCartStockState();
  });
}

function showKfToast(message, isError = false) {
  if (!message) return;

  let toast = document.getElementById('kf-toast');
  if (!toast) {
    toast = document.createElement('div');
    toast.id = 'kf-toast';
    toast.className = 'kf-toast';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    document.body.appendChild(toast);
  }

  toast.textContent = message;
  toast.classList.toggle('kf-toast--error', isError);
  toast.classList.add('is-visible');

  window.clearTimeout(kfToastTimer);
  kfToastTimer = window.setTimeout(() => {
    toast.classList.remove('is-visible');
  }, 2800);
}

async function addVariantToCart(variantId, quantity) {
  const response = await fetch(`${routes.cart_add_url}.js`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify({
      id: String(variantId),
      quantity,
    }),
  });

  if (!response.ok) {
    let errorMessage = 'Toevoegen aan winkelwagen mislukt.';

    try {
      const errorJson = await response.json();
      errorMessage = errorJson?.description || errorJson?.message || errorMessage;
    } catch (error) {
      console.error(error);
    }

    const addToCartError = new Error(errorMessage);
    addToCartError.status = response.status;
    throw addToCartError;
  }

  return response.json();
}

async function fetchCartSections() {
  const sectionsUrl = `/?sections=cart-icon-bubble,cart-drawer`;
  const response = await fetch(sectionsUrl, {
    headers: { Accept: 'application/json' },
  });

  if (!response.ok) return null;

  try {
    return await response.json();
  } catch (error) {
    console.error(error);
    return null;
  }
}

function renderCartIconBubbleSection(sectionHtml) {
  if (!sectionHtml) return false;

  const cartIconBubble = document.getElementById('cart-icon-bubble');
  if (!cartIconBubble) return false;

  const parsedHtml = new DOMParser().parseFromString(sectionHtml, 'text/html');
  const source = parsedHtml.querySelector('.shopify-section');

  cartIconBubble.innerHTML = source ? source.innerHTML : sectionHtml;
  return true;
}

function renderCartDrawerSection(addResponse) {
  const cartDrawer = document.querySelector('cart-drawer');
  if (!cartDrawer || !addResponse?.sections?.['cart-drawer']) return false;

  if (typeof cartDrawer.renderContents === 'function') {
    cartDrawer.renderContents(addResponse);
  }

  if (addResponse.item_count > 0) {
    cartDrawer.classList.remove('is-empty');
  }

  return true;
}

async function fetchCartState() {
  if (kfCachedCartData) {
    return kfCachedCartData;
  }

  const cartResponse = await fetch(`${routes.cart_url}.js`, {
    headers: { Accept: 'application/json' },
  });

  if (!cartResponse.ok) {
    throw new Error('Winkelwagen kon niet worden bijgewerkt.');
  }

  const cartData = await cartResponse.json();
  kfCachedCartData = cartData;
  return cartData;
}

function getVariantQuantityInCart(cartData, variantId) {
  if (!cartData?.items?.length) return 0;

  return cartData.items.reduce((total, item) => {
    const isSameVariant = String(item.id) === String(variantId) || String(item.variant_id) === String(variantId);
    return isSameVariant ? total + (Number(item.quantity) || 0) : total;
  }, 0);
}

function updateAddButtonsStockState(containerElement, cartData) {
  if (!containerElement) return [];

  const addButtons = Array.from(containerElement.querySelectorAll('[data-kf-add-to-cart]'));
  if (!addButtons.length) return;

  const scope = containerElement.hasAttribute('data-kf-pdp-actions') ? 'pdp' : 'card';

  addButtons.forEach((button) => {
    const variantId = button.dataset.variantId;
    if (!variantId) return;

    const addQuantity = Number(button.dataset.kfQty) || 1;
    const variantAvailable = button.dataset.variantAvailable !== 'false';
    const inventoryManaged = button.dataset.inventoryManaged === 'true';
    const inventoryPolicy = button.dataset.inventoryPolicy || 'deny';
    const inventoryKnown = button.dataset.inventoryKnown !== 'false';
    const inventoryQuantity = Number(button.dataset.inventoryQty);

    let shouldDisable = false;
    let disableReason = 'allowed';
    let currentInCartQty = 0;

    if (inventoryManaged && inventoryPolicy !== 'continue' && inventoryKnown && Number.isFinite(inventoryQuantity)) {
      currentInCartQty = getVariantQuantityInCart(cartData, variantId);
      if (variantAvailable === false) {
        shouldDisable = true;
        disableReason = 'variant_unavailable';
      } else if (inventoryQuantity > 0) {
        shouldDisable = currentInCartQty + addQuantity > inventoryQuantity;
        if (shouldDisable) disableReason = 'cart_plus_add_exceeds_inventory';
      } else {
        // Defensive fallback: variant availability is more reliable than a transient zero quantity read.
        shouldDisable = false;
        disableReason = 'inventory_zero_but_variant_available';
      }
    }

    button.disabled = shouldDisable;
    button.setAttribute('aria-disabled', shouldDisable ? 'true' : 'false');

  });

  return addButtons;
}

function updateCardStockState(cardElement, cartData) {
  if (!cardElement) return;

  const addButtons = updateAddButtonsStockState(cardElement, cartData);
  if (!addButtons?.length) return;

  const stockIndicator = cardElement.querySelector('.kf-wine-card__stock');
  if (!stockIndicator) return;

  const enabledButtons = addButtons.filter((button) => !button.disabled);
  const flesButton = addButtons.find((button) => Number(button.dataset.kfQty || '1') === 1);
  const boxButton = addButtons.find((button) => Number(button.dataset.kfQty || '1') >= 6);

  let stockLabel = 'Op voorraad';
  let soldOut = false;
  let limited = false;

  if (enabledButtons.length === 0) {
    stockLabel = 'Uitverkocht';
    soldOut = true;
  } else if (flesButton && !flesButton.disabled && boxButton && boxButton.disabled) {
    limited = true;
  }

  if (!soldOut && flesButton) {
    const inventoryQuantity = Number(flesButton.dataset.inventoryQty);
    if (Number.isFinite(inventoryQuantity) && inventoryQuantity > 0) {
      const currentInCartQty = getVariantQuantityInCart(cartData, flesButton.dataset.variantId);
      const availableQuantity = Math.max(0, inventoryQuantity - currentInCartQty);

      if (availableQuantity === 0) {
        stockLabel = 'Uitverkocht';
        soldOut = true;
        limited = false;
      } else if (limited) {
        stockLabel = 'Voorraad laag';
      } else {
        stockLabel = 'Op voorraad';
      }
    } else if (limited) {
      stockLabel = 'Voorraad laag';
    }
  } else if (limited) {
    stockLabel = 'Voorraad laag';
  }

  stockIndicator.textContent = stockLabel;
  stockIndicator.classList.toggle('kf-wine-card__stock--sold-out', soldOut);
  stockIndicator.classList.toggle('kf-wine-card__stock--limited', limited && !soldOut);
}

function updatePdpStockState(actionsElement, cartData) {
  if (!actionsElement) return;
  updateAddButtonsStockState(actionsElement, cartData);
}

function updateAllCardsStockState(cartData) {
  document.querySelectorAll('.kf-wine-card').forEach((card) => {
    updateCardStockState(card, cartData);
  });
}

function updateAllPdpStockState(cartData) {
  document.querySelectorAll('[data-kf-pdp-actions]').forEach((actions) => {
    updatePdpStockState(actions, cartData);
  });
}

function updateAllAddToCartStockState(cartData) {
  updateAllCardsStockState(cartData);
  updateAllPdpStockState(cartData);
}

async function refreshAllAddToCartStockState(cartData = null) {
  try {
    const state = cartData || (await fetchCartState());
    updateAllAddToCartStockState(state);
  } catch (error) {
    console.error(error);
  }
}

window.kfRefreshAddToCartStockState = refreshAllAddToCartStockState;

window.addEventListener('DOMContentLoaded', () => {
  refreshAllAddToCartStockState();
});

document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-kf-add-to-cart]');
  if (!button) return;

  if (button.disabled || button.getAttribute('aria-disabled') === 'true') return;

  event.preventDefault();
  if (button.classList.contains('is-adding')) return;

  const variantId = button.dataset.variantId;
  if (!variantId) return;

  const addQuantity = Number(button.dataset.kfQty) || 1;
  if (addQuantity <= 0) return;

  const inventoryManaged = button.dataset.inventoryManaged === 'true';
  const inventoryPolicy = button.dataset.inventoryPolicy || 'deny';
  const inventoryKnown = button.dataset.inventoryKnown !== 'false';
  const variantAvailable = button.dataset.variantAvailable !== 'false';
  const inventoryQuantity = Number(button.dataset.inventoryQty);

  const card = button.closest('.kf-wine-card');
  button.classList.add('is-adding');

  try {
    if (inventoryManaged && inventoryPolicy !== 'continue' && inventoryKnown && Number.isFinite(inventoryQuantity)) {
      if (variantAvailable === false) {
        showKfToast('Deze variant is niet beschikbaar.', true);
        button.classList.remove('is-adding');
        return;
      }

      const cartBeforeAdd = await fetchCartState();
      const currentInCartQty = getVariantQuantityInCart(cartBeforeAdd, variantId);

      if (inventoryQuantity > 0 && currentInCartQty + addQuantity > inventoryQuantity) {
        showKfToast('Niet genoeg voorraad beschikbaar.', true);
        button.classList.remove('is-adding');
        return;
      }
    }

    if (card) animateBottleToCart(card);
    await addVariantToCart(variantId, addQuantity);
    kfCachedCartData = null;
    const cartStatePromise = fetchCartState();
    const sectionsPromise = fetchCartSections();

    const sections = await sectionsPromise;
    const cartData = await cartStatePromise;
    kfCachedCartData = cartData;

    let didRenderDrawer = false;
    if (sections?.['cart-drawer']) {
      didRenderDrawer = renderCartDrawerSection({
        id: Number(variantId),
        item_count: cartData.item_count,
        sections,
      });
    }

    if (!didRenderDrawer && sections?.['cart-icon-bubble']) {
      renderCartIconBubbleSection(sections['cart-icon-bubble']);
    }

    updateCartBubbleCount(cartData.item_count);
    updateAllAddToCartStockState(cartData);

    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'kf-card-product',
        productVariantId: variantId,
        cartData,
      });
    }

    showKfToast('Toegevoegd aan winkelwagen.');
  } catch (error) {
    console.error(error);
    kfCachedCartData = null;

    if (error?.status === 422) {
      showKfToast(error.message || 'Niet genoeg voorraad beschikbaar.', true);
    } else {
      showKfToast('Er ging iets mis. Probeer het opnieuw.', true);
    }
  } finally {
    button.classList.remove('is-adding');
  }
});
